import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const ConfigContext = createContext(null);
export const useConfig = () => useContext(ConfigContext);

const DEFAULTS = { whatsapp: "", email: "", direccion: "", instagram: "" };

export const ConfigProvider = ({ children }) => {
    const [config, setConfig] = useState(DEFAULTS);

    const load = () => api.get("/settings/general").then((r) => setConfig({ ...DEFAULTS, ...r.data })).catch(() => {});

    useEffect(() => { load(); }, []);

    const waNumber = (config.whatsapp || "").replace(/\D/g, "");
    const hasWhatsApp = waNumber.length >= 7;
    const waHref = (text) => (hasWhatsApp ? `https://wa.me/${waNumber}?text=${encodeURIComponent(text || "")}` : null);

    return (
        <ConfigContext.Provider value={{ config, setConfig, reloadConfig: load, hasWhatsApp, waHref }}>
            {children}
        </ConfigContext.Provider>
    );
};
